import React from 'react';
import { DalanyLogo, DalanyTextLogo, DalanyKurdishTextLogo, DalanyArabicTextLogo } from './icons';

const Header: React.FC = () => {
  return (
    <thead>
      <tr>
        <td>
          <div className="pb-8 border-b border-slate-200/80 mb-10">
            <div className="flex items-start justify-between">
              {/* Left side: Logo and English Name */}
              <div className="flex items-center space-x-4">
                <DalanyLogo className="h-14 w-14 text-brand" />
                <div>
                  <div className="flex items-baseline space-x-2">
                    <DalanyTextLogo className="h-9 text-brand" />
                    <span className="text-3xl font-semibold text-slate-700 tracking-tight">Lab</span>
                  </div>
                  <p className="text-sm text-slate-500 tracking-wide mt-1">For Pathological Analysis</p>
                </div>
              </div>
              
              {/* Right side: Multilingual Name */}
              <div className="font-rabar flex flex-col items-end pt-1">
                  <div dir="rtl" className="flex items-baseline gap-3 text-slate-800 text-3xl">
                      <span className="font-rabar-bold">تاقیگەی</span>
                      <DalanyKurdishTextLogo className="h-7" />
                  </div>
                   <div dir="rtl" className="text-lg text-slate-500 mt-1">
                       <span>بۆ شیکاری نەخۆشیەکان</span>
                   </div>
                  <div dir="rtl" className="flex items-baseline gap-3 text-slate-400 text-base mt-2">
                      <span>مختبر</span>
                      <DalanyArabicTextLogo className="h-5 relative top-[2px]" />
                      <span>للتحاليلات المرضية</span>
                  </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </thead>
  );
};

export default Header;